module.exports = require("./seh.d.ts");